import { Phone, Ruler, ShieldCheck, Hammer, CheckCircle } from "lucide-react";
import ScrollReveal from "./ScrollReveal";

const steps = [
  {
    icon: Phone,
    title: "Call or Text for an Estimate",
    description: "Reach out to discuss your project and get a free estimate.",
  },
  {
    icon: Ruler,
    title: "In-Home Measure & Plan",
    description: "We visit your home to take precise measurements and finalize the plan.",
  },
  {
    icon: ShieldCheck,
    title: "Prep & Protection",
    description: "Your space is carefully prepped and protected before work begins.",
  },
  {
    icon: Hammer,
    title: "Install or Sand & Finish",
    description: "Professional installation or refinishing with attention to every detail.",
  },
  {
    icon: CheckCircle,
    title: "Final Walkthrough",
    description: "We walk through the completed project together to ensure your satisfaction.",
  },
];

const WhatToExpect = () => {
  return (
    <section className="py-20 bg-primary">
      <div className="container mx-auto px-4">
        <ScrollReveal>
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-primary-foreground mb-4">
              What to Expect
            </h2>
            <p className="text-lg md:text-xl text-primary-foreground/80 max-w-2xl mx-auto">
              From first call to final walkthrough, here's how we work.
            </p>
          </div>
        </ScrollReveal>

        <div className="relative">
          {/* Timeline line - desktop */}
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-1 bg-accent/30" />
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-4">
            {steps.map((step, index) => (
              <ScrollReveal key={index} delay={index * 0.15} direction="up">
                <div className="relative flex flex-col items-center text-center">
                  {/* Step number and icon */}
                  <div className="relative z-10 w-24 h-24 bg-accent rounded-full flex items-center justify-center mb-6 shadow-lg">
                    <step.icon className="w-10 h-10 text-accent-foreground" />
                  </div>
                  
                  {/* Step number badge */}
                  <div className="absolute top-0 right-1/2 translate-x-12 -translate-y-0 w-8 h-8 bg-primary-foreground text-primary rounded-full flex items-center justify-center font-heading font-bold text-sm shadow-md">
                    {index + 1}
                  </div>
                  
                  <h3 className="font-heading font-bold text-lg text-primary-foreground mb-2">
                    {step.title}
                  </h3>
                  <p className="text-primary-foreground/70 text-sm leading-relaxed max-w-xs">
                    {step.description}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatToExpect;
